/* eslint-disable @next/next/no-img-element */
import React from 'react'
import Image from 'next/image'

interface TrustPilotStaticReviewsProps {
    width: number
    onClick?: () => void
    isAboveTheFold?: boolean // determines if we should set priority
}

// When to set priority (isAboveTheFold) to true?
// priority preloads the image in the HTML to improve LCP performance
// Only use for images above the fold(hero section, header logos)
// Avoid adding priority to all images — it can hurt performance

export default function TrustpilotStaticReviews({ width = 80, onClick, isAboveTheFold = false }: TrustPilotStaticReviewsProps) {
    // calculate height dynamically based on aspect ratio
    const height = Math.round(width / 1.585)
    return (
        <a
            href="https://uk.trustpilot.com/review/zuto.com"
            target="_blank"
            rel="noreferrer"
            onClick={onClick}
            data-testid="trustpilot"
            style={{ height: '40px' }}
        >
            <Image
                src="https://cdn.zuto.cloud/assets/images/trustpilot/Trustpilot_currentReviews.svg"
                alt="Trustpilot reviews"
                width={width}
                height={height}
                style={{ width: `${width}px`, height: 'auto' }}
                priority={isAboveTheFold}
                loading={isAboveTheFold ? 'eager' : 'lazy'}
            />
        </a>
    )
}